import { render, staticRenderFns } from "./purchaseStat.vue?vue&type=template&id=503b2473&scoped=true&"
import script from "./purchaseStat.vue?vue&type=script&lang=js&"
export * from "./purchaseStat.vue?vue&type=script&lang=js&"
import style0 from "./purchaseStat.vue?vue&type=style&index=0&id=503b2473&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503b2473",
  null
  
)

component.options.__file = "purchaseStat.vue"
export default component.exports